<div class="container">
    <div class="block">
        <div echarts [options]="options" class="demo-chart"></div>
    </div>
</div>